import axios, { AxiosResponse } from 'axios';

export const prepareFileIsinApi = (id: number, fileName: string) => {
    return axios({
        method: 'GET',
        url: `ISIN/${id}/Prepare?file=${fileName}`
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export const prepareFileAmlz = (idzad: number | string, fileName: string, isSmsLogin?: boolean, idOsoby?: number) => {
    return axios({
        method: 'PUT',
        // url: `/AML/${idzad}/prepare`,
        url: isSmsLogin ? `/AMLodkaz/${idzad}/osobac2/${idOsoby}/prepare` : `/AML/${idzad}/prepare`,
        data: {
            tempnazev: fileName
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};
